/* Bean Theory – live open/closed status for café cards.
   Markup: <div data-bt-status data-hours='{"0":"08:00-17:00",...}'><span class="bt__dot"></span><span data-bt-status-text></span></div>
   Keys are JS weekdays (0 = Sunday). Empty or missing = closed. */
(function () {
  function label(t) {
    var p = t.split(':'), h = parseInt(p[0], 10), m = p[1] || '00';
    var suf = h >= 12 ? 'pm' : 'am';
    if (h > 12) h -= 12;
    if (h === 0) h = 12;
    return h + (m !== '00' ? ':' + m : '') + suf;
  }
  function mins(t) { var p = t.split(':'); return parseInt(p[0], 10) * 60 + parseInt(p[1] || '0', 10); }
  function now() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      var get = function (k) { for (var i = 0; i < parts.length; i++) if (parts[i].type === k) return parts[i].value; return ''; };
      var map = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
      return { day: map[get('weekday')], min: (parseInt(get('hour'), 10) % 24) * 60 + parseInt(get('minute'), 10) };
    } catch (e) { return null; }
  }
  var names = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  function run(root) {
    var n = now();
    if (!n) return;
    (root || document).querySelectorAll('[data-bt-status][data-hours]').forEach(function (el) {
      var hours; try { hours = JSON.parse(el.getAttribute('data-hours')); } catch (e) { return; }
      var txt = el.querySelector('[data-bt-status-text]');
      var today = (hours[n.day] || '').split('-');
      if (today.length === 2) {
        var o = mins(today[0]), c = mins(today[1]);
        if (n.min >= o && n.min < c) { el.dataset.state = 'open'; txt.textContent = 'Open now · until ' + label(today[1]); return; }
        if (n.min < o) { el.dataset.state = 'closed'; txt.textContent = 'Opens today at ' + label(today[0]); return; }
      }
      el.dataset.state = 'closed';
      for (var i = 1; i <= 7; i++) {
        var d = (n.day + i) % 7, h = (hours[d] || '').split('-');
        if (h.length === 2) { txt.textContent = 'Closed · opens ' + (i === 1 ? 'tomorrow' : names[d]) + ' ' + label(h[0]); return; }
      }
      txt.textContent = 'Closed';
    });
  }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', function () { run(); });
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
